import { Eye, Filter } from '@wolfejs/icons/IconMap';
import type { RadioItem } from '@wolfejs/ui/RadioGroupList/RadioGroupList';
import type { SelectOption } from '@wolfejs/ui/Select/Select';
import type { OrderHistoryData } from './types';

export const statusFilters: RadioItem[] = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Ordering',
    value: 'ordering',
  },
  {
    label: 'Pre-Processing',
    value: 'pre_processing',
  },
  {
    label: 'Processing',
    value: 'processing',
  },
  {
    label: 'Post-Processing',
    value: 'post_processing',
  },
  {
    label: 'Processed',
    value: 'processed',
  },
  {
    label: 'Fulfilled',
    value: 'fulfilled',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
  {
    label: 'Locked',
    value: 'locked',
  },
];

const date = new Date(new Date().setUTCHours(0, 0, 0, 0));
export const dateOptions: SelectOption<string>[] = [
  { label: 'Today', value: date.toString() },
  { label: 'Yesterday', value: new Date(date.setDate(date.getDate() - 1)).toString() },
  { label: 'Last 7 days', value: new Date(date.setDate(date.getDate() - 7)).toString() },
  { label: 'Month to Date', value: new Date(date.setMonth(date.getMonth() - 1)).toString() },
  { label: 'Year to Date', value: new Date(date.setFullYear(date.getFullYear() - 1)).toString() },
  { label: 'All Time', value: new Date(date.setFullYear(date.getFullYear() - 999)).toString() },
];

export const filterOptions: SelectOption<string>[] = [
  {
    label: (
      <div className="flex items-center gap-2">
        <Filter />
        Filter
      </div>
    ),
  },
];

export enum OrderHistoryLabels {
  orderId = 'ORDER ID',
  itemsCount = 'ITEMS',
  datePlaced = 'DATE PLACED',
  price = 'PRICE',
  status = 'STATUS',
}

export const orderHistoryTableSchema = {
  orderId: 'string',
  itemsCount: 'string',
  price: 'human-currency',
  datePlaced: 'date',
  status: 'badge',
};

export const popoverActionItems = [
  {
    icon: <Eye />,
    text: 'View Order',
    id: 'view',
  },
];

export const defaultOrderHistoryData: OrderHistoryData = {
  id: '1',
  orderId: '1846325',
  price: 466,
  datePlaced: new Date('2024-03-27T10:30:16.029Z'),
  status: 'Completed',
};
